export enum JobsFilterType {
  STATUS = 'Status',
  SCHEDULED_DATE = 'ScheduleDate',
  REQUEST_DATE = 'RequestDate',
  COMPLETION_DATE = 'CompletedAt',
  CREATED_AT = 'CreatedAt',
  ASSIGNED_EMPLOYEE_ID = 'AssignedEmployeeId',
  ASSIGNED_VEHICLE_ID = 'AssignedVehicleId',
  ASSIGNED_EQUIPMENT_ID = 'AssignedEquipmentId'
}

export enum HaulageJobFilterType {
  CUSTOMER_ID = 'CustomerId',
  WASTE_COLLECTION_PROVIDER_ID = 'WasteCollectionProviderId',
  WASTE_COLLECTION_SITE_ID = 'WasteCollectionSiteId',
  DELIVERY_AD_PLANT_SITE_ID = 'DeliveryADPlantSiteId'
}

export enum DigestateJobFilterType {
  PICKUP_AD_PLANT_SITE_ID = 'PickupADPlantSiteId',
  FARM_ID = 'FarmId',
  DIGESTATE_PRODUCT_ID = 'DigestateProductId',
  SILO_ID = 'SiloId'
}

export enum SpreadingJobFilterType {
  WIND_DIRECTION = 'WindDirection',
  CLOUD_CONDITION = 'CloudCondition',
  FIELD_CONDITION = 'FieldCondition',
  FARM_ID = 'FarmId',
  SILO_ID = 'SiloId'
}

export enum TimesheetFilterType {
  TYPE = 'Type',
  DATE = 'Date',
  NIGHT_OUT = 'IsNightOut',
  EMPLOYEE_ID = 'EmployeeId',
  VEHICLE_ID = 'VehicleId',
  EQUIPMENT_ID = 'EquipmentId'
}

export enum ProductFilterType {
  TYPE = 'Type',
  CATEGORY = 'Category'
}
